import { State, IColumn } from "./dataTable.common";
import React from "react";
import _ from "lodash";
import { safebind } from "../helpers";
import { CheckBox } from "./checkBox2";

export interface SelectColumnProps<T> {
  keySelector?: (obj: T, index: number) => string;
  data?: T[];
  onSelectionChanged: (selectedItems: T[]) => void;
  selectedItems: T[];
  disabled?: (rowData: T) => boolean;
  visible?: (rowData: T) => boolean;
  canSelectAll?: boolean;
  onSetState?: () => void;
  style?: React.CSSProperties;
  headerStyle?: React.CSSProperties;
  noPrint?: boolean;
}

export class SelectColumn<T> extends React.Component<
  SelectColumnProps<T>,
  State<T>
> implements IColumn<SelectColumnProps<any>, State<any>> {
  constructor(props: SelectColumnProps<T>, state: State<T>) {
    super(props);
    this.state = state;
    if (this.props.selectedItems && this.state.internalData) {
      state.selectedItems = _.intersectionWith<T>(
        this.props.selectedItems,
        this.props.data || [],
        (x, y) =>
          this.props.keySelector!(x, -1) === this.props.keySelector!(y, -2)
      );
      if (this.state.selectedItems.length !== this.props.selectedItems.length)
        this.props.onSelectionChanged(state.selectedItems);
    }
  }
  getFilterTemplate = () => { return null; }

  getFilterBy = () => { return null; }

  style?: React.CSSProperties | undefined;

  getHeadRow() {

    if (this.props.canSelectAll === false) return <span />;

    if (
      this.props.selectedItems.length > 0 &&
      this.props.selectedItems.length < this.props.data!.length
    ) {
      const intersection = _.intersectionWith<T>(
        this.props.selectedItems,
        this.state.itemsDisplayed,
        (x, y) =>
          this.props.keySelector!(x, -1) === this.props.keySelector!(y, -2)
      );

      if (
        intersection.length >= this.state.itemsDisplayed.length ||
        intersection.length === 0
      ) {
        return (
          <div
            className="text-center"
            style={{
              color: "#31708f",
              backgroundColor: "#d9edf7",
              borderColor: "#bce8f1",
              padding: 2
            }}
          >
            <span>{intersection.length} </span> elementi totali selezionati
            nella pagina corrente.
            <strong>
              <a
                onClick={safebind(
                  this.props.onSelectionChanged,
                  this,
                  this.state.filteredItems
                )}
              >
                {" "}
                Seleziona Tutto
              </a>
            </strong>{" "}
            o
            <strong>
              <a onClick={safebind(this.props.onSelectionChanged, this, [])}>
                {" "}
                Deseleziona Tutto{" "}
              </a>
            </strong>
          </div>
        );
      }
    }

    return <span />;
  }
  canGroup() {
    return false;
  }
  getGroupTemplate(groupKey: any) {
    return "";
  }
  canOrder() {
    return false;
  }
  canFilter() {
    return false;
  }
  getCommands() {
    return [];
  }
  getSummaryItem(elements: T[]) {
    return (
      <span>
        {" "}
        <i className="far fa-check-square" style={{ marginRight: 5 }} />
        {this.state.selectedItems
          ? "Sel: " + this.state.selectedItems.length
          : "Tot.Selezionati: 0"}
      </span>
    );
  }

  getHeader(elements: T[]) {
    if (this.props.canSelectAll === false) return <div />;
    return (
      <CheckBox

        checked={this.areChecked(elements)}
        onChange={safebind(this.select, this, elements)}
      />
    );
  }

  getCell(datarow: T) {
    var disabled = this.props.disabled && this.props.disabled(datarow);
    var visible = this.props.visible ? this.props.visible(datarow) : true;

    if (visible) {
      var checked =
        _.find(
          this.state.selectedItems,
          x =>
            this.props.keySelector!(x, -1) ===
            this.props.keySelector!(datarow, -2)
        ) !== undefined && !disabled;
      return (
        <CheckBox
          checked={checked}
          onChange={e => this.onCheckChange(datarow, e)}
          disabled={disabled}
        />
      );
    } else {
      return (<></>)
    }

  }

  getDefaultGroupingIndex(): any {
    return undefined;
  }

  getValueForFooter(): any {
    return undefined;
  }

  getTitle() {
    return undefined;
  }

  areChecked = (elements: T[]): boolean => {
    return (
      _.differenceWith(
        elements,
        this.state.selectedItems,
        (x, y) =>
          this.props.keySelector!(x, -1) === this.props.keySelector!(y, -2)
      ).length == 0 && !this.props.disabled
    );
  };

  select = (elements: T[], checked: boolean): void => {
    let selectedItems: T[];
    if (checked) {
      selectedItems = _.unionBy(
        this.state.selectedItems,
        elements,
        this.props.keySelector as any
      );
    } else {
      selectedItems = _.differenceBy(
        this.state.selectedItems,
        elements,
        this.props.keySelector as any
      );
    }
    this.setState({ selectedItems }, () => this.props.onSetState!());
    if (this.props.onSelectionChanged)
      this.props.onSelectionChanged(selectedItems);
  };

  onCheckChange = (item: any, checked: boolean): void => {
    var found = _.find(
      this.state.selectedItems,
      x => this.props.keySelector!(x, 0) === this.props.keySelector!(item, 0)
    );
    if (!checked) {
      if (found !== undefined) {
        var index = this.state.selectedItems.indexOf(found);
        this.state.selectedItems.splice(index, 1);
      }
    } else {
      if (found === undefined) {
        this.state.selectedItems.push(item);
      }
    }
    (this.props as any).onSetState();
    if (this.props.onSelectionChanged)
      this.props.onSelectionChanged(this.state.selectedItems);
  };

  isHidden = () => {
    return false;
  }

  canHide() {
    return false;
  }

  canExport() {
    return false;
  }

  getExportTemplate() {
    return null;
  }
}
